export enum VisitType {
  RationingTool = 'Daily Allowance',
  WeightManagement = 'Weight management',
  SmartReco = 'Smart Recommendation',
  RapidReco = 'Rapid Reco',
  RenalDetect = 'Renal Detect',
}
